import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { ReUnixCron } from '@sbzen/re-cron/unix/unix';
import { Tab } from '@sbzen/re-cron';
import { ControlledInput } from '../ControlledInput';
import { ReactComponent as StarIcon } from 'assets/star_required_icon.svg';
import { ICronDataSelectProps } from './types';
import styles from './cronDataSelect.module.scss';

const CronDataSelect: FC<ICronDataSelectProps> = ({ name, label }) => {
  const formContext = useFormContext();

  const { control } = formContext;

  return (
    <div className={styles.wrapper}>
      {label && (
        <div className={styles.label}>
          <p className={styles.labelText}>{label}</p>
          <StarIcon className={styles.requiredIcon} />
        </div>
      )}
      <Controller
        control={control}
        name={name}
        rules={{ required: true }}
        render={({ field: { value, onChange } }) => (
          <>
            <ControlledInput type='text' name={name} value={value} readOnly />
            <ReUnixCron
              tabs={[Tab.MINUTES, Tab.HOURS, Tab.DAY]}
              value={value}
              onChange={(val) => {
                onChange(val);
              }}
            />
          </>
        )}
      />
    </div>
  );
};

export default CronDataSelect;
